<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      <span>
        {{ $t("AppFooter.copyright") }} © {{ new Date().getFullYear() }}
        <a
          href="https://autofaktura.com"
          target="_blank"
          rel="noopener noreferrer"
        >AutoFaktura</a>,
        {{ $t("AppFooter.reserved") }}
      </span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
